












import Vue from 'vue';
import { DateRangePicker } from 'mycorems-app-shared';
import { DateRange } from '@/types';

export default Vue.extend({
  props: {
    startDate: String,
    endDate: String,
  },
  computed: {
    range(): DateRange {
      return {
        start: this.startDate,
        end: this.endDate,
      };
    },
  },
  methods: {
    clear(): void {
      this.$emit('clear', null);
    },
    selectRange(range: DateRange) {
      this.$emit('input', range);
    },
  },
  components: {
    DateRangePicker,
  },
});
